import { Button, Container, Stack, Text, Title } from '@mantine/core'
import { Link } from 'react-router-dom'
import { Seo } from '../components/Seo'

export default function NotFoundPage() {
  return (
    <>
      <Seo
        title="Страница не найдена"
        description="Запрошенная страница не найдена."
        canonical="/"
        noindex
      />
      <Container
        size="sm"
        py="xl"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack gap="md" align="center" style={{ width: '100%' }}>
          <Title order={1}>404</Title>
          <Title order={3}>Страница не найдена</Title>
          <Text c="dimmed" ta="center">
            Возможно, адрес введен с ошибкой или страница была удалена.
          </Text>
          <Button component={Link} to="/" radius="xl">
            Вернуться на главную
          </Button>
        </Stack>
      </Container>
    </>
  )
}
